var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { memo, useEffect, useRef, useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { ErrorBoundary } from '@web/utils';
import { styled } from '@web/theme';
import { Button } from '../../../Button';
import { usePage, usePageEdit } from '../../../';
import { ImageWrapper, StyledHero } from './Hero.Styles';
import { HeroImageEditor } from './HeroImageEditor';
import { SlideImage } from './SlideImage';
var transition = {
    duration: .2
};
export var animationVariants = {
    enter: {
        opacity: 0,
        zIndex: 1,
        transition: transition
    },
    center: {
        opacity: 1,
        zIndex: 1,
        transition: transition
    },
    exit: {
        opacity: 1,
        zIndex: 0,
        transition: transition
    }
};
export var Hero = memo(function (_a) {
    var height = _a.height;
    var _b = usePage(), pageId = _b.pageId, pageIsFetching = _b.pageIsFetching, pagePhotoURL = _b.pagePhotoURL;
    var pageInEditMode = usePageEdit().pageInEditMode;
    var _c = useState(''), photoURL = _c[0], setPhotoURL = _c[1];
    var _d = useState(height), imgHeight = _d[0], setImgHeight = _d[1];
    var _e = useState(false), uploadNew = _e[0], setUploadNew = _e[1];
    var allowUpload = function () { return setUploadNew(true); };
    var closeUpload = function () { return setUploadNew(false); };
    var refImage = useRef(null);
    useEffect(function () {
        window.addEventListener('resize', resizeImage);
        return function () {
            window.removeEventListener('resize', resizeImage);
        };
    }, []);
    useEffect(function () {
        if (pagePhotoURL)
            setPhotoURL(pagePhotoURL);
    }, [pagePhotoURL]);
    useEffect(function () {
        setPhotoURL(pagePhotoURL);
    }, [pageId]);
    useEffect(function () {
        if (!pageInEditMode && uploadNew)
            setUploadNew(false);
    }, [pageInEditMode]);
    var resizeImage = function () {
        if (refImage && refImage.current) {
            var imgHeight_1 = (refImage.current.offsetWidth / 19) * 7;
            if (refImage.current.offsetHeight !== imgHeight_1)
                setImgHeight(imgHeight_1);
        }
    };
    return (React.createElement(ErrorBoundary, null,
        React.createElement(StyledHero, { style: { height: height + "px" } },
            React.createElement(AnimatePresence, { exitBeforeEnter: false, initial: true },
                React.createElement(ImageWrapper, { key: pageId, initial: "enter", animate: "center", exit: "exit", variants: animationVariants, ref: refImage },
                    pageInEditMode && uploadNew &&
                        React.createElement(HeroImageEditor, { height: imgHeight, onClose: closeUpload }),
                    !uploadNew &&
                        React.createElement(SlideImage, { isFetching: pageIsFetching, images: photoURL, size: height }))),
            pageInEditMode && !uploadNew &&
                React.createElement(ChangeImageButton, { onClick: allowUpload }, "Zm\u011Bnit obr\u00E1zek"))));
});
var ChangeImageButton = styled(Button)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tmin-height: 32px;\n\tmargin: auto auto 1rem auto;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 2;\n"], ["\n\tmin-height: 32px;\n\tmargin: auto auto 1rem auto;\n\talign-items: center;\n\tjustify-content: center;\n\tz-index: 2;\n"])));
var templateObject_1;
